var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PhoenixLoader } from './phoenix-loader';
/**
 * PhoenixLoader for processing and loading an event from TrackML.
 */
var TrackmlLoader = /** @class */ (function (_super) {
    __extends(TrackmlLoader, _super);
    /**
     * Instiantiate the TrackML loader.
     */
    function TrackmlLoader() {
        var _this = _super.call(this) || this;
        _this.hitData = [];
        _this.particleData = [];
        _this.truthData = {};
        return _this;
    }
    /**
     * Process Hits to format and store them.
     * @param hits Hits to be processed.
     */
    TrackmlLoader.prototype.processHits = function (hits) {
        var data = hits.split('\n');
        console.log('Event has this many hits:', data.length);
        var values;
        // format is: hit_id,x,y,z,volume_id,layer_id,module_id
        for (var line = 1; line < data.length; line++) {
            values = data[line].split(',');
            this.hitData[values[0]] = [parseFloat(values[1]), parseFloat(values[2]), parseFloat(values[3])];
        }
    };
    /**
     * Process Particles to format and store them.
     * @param particles Particles to be processed.
     */
    TrackmlLoader.prototype.processParticles = function (particles) {
        var data = particles.split('\n');
        console.log('Event has this many particles:', data.length);
        var values;
        // format is: particle_id,vx,vy,vz,px,py,pz,q,nhits
        for (var line = 1; line < data.length; line++) {
            values = data[line].split(',');
            this.particleData.push({
                // tslint:disable-next-line:radix
                particle_id: parseInt(values[0]),
                vertex_pos: [parseFloat(values[1]), parseFloat(values[2]), parseFloat(values[3])],
                mom: [parseFloat(values[4]), parseFloat(values[5]), parseFloat(values[6])]
            });
        }
    };
    /**
     * Process Truth data to format and store it.
     * @param truth Truth data to be processed.
     */
    TrackmlLoader.prototype.processTruth = function (truth) {
        var data = truth.split('\n');
        console.log('Event has this many truth: ', data.length);
        var values;
        // format is: hit_id,particle_id,tx,ty,tz,tpx,tpy,tpz,weight
        for (var line = 1; line < data.length; line++) {
            values = data[line].split(',');
            this.truthData[values[0]] = [values[1], values[2], values[3], values[4], values[5], values[6], values[7], values[8]];
        }
    };
    /**
     * Get structured event data from the processed Hits, Truth data and Particles.
     * @param eventNum Event number.
     */
    TrackmlLoader.prototype.getEventData = function (eventNum) {
        var eventData = {
            eventNumber: eventNum,
            runNumber: 0,
            Hits: undefined,
            Tracks: undefined
        };
        if (this.hitData) {
            eventData.Hits = {};
            eventData.Hits.Reconstructed = [];
            var mod = Math.round(this.hitData.length / 5000);
            if (mod < 1) {
                mod = 1;
            }
            var count = 0;
            for (var i = 1; i < this.hitData.length; i++) {
                if (i % mod) {
                    continue;
                }
                eventData.Hits.Reconstructed[count++] = [[this.hitData[i][0], this.hitData[i][1], this.hitData[i][2]]];
            }
        }
        console.log('Will show this many hits', eventData.Hits.Reconstructed.length);
        if (this.truthData) {
            eventData.Tracks = { Particles: [] };
            if (this.particleData) {
                for (var i = 0; i < this.particleData.length; i++) {
                    // Add the relevant data from particle, such as first hit position - we'll add the particle_id because we need it later.
                    eventData.Tracks.Particles[i]
                        = {
                            particle_id: this.particleData[i].particle_id,
                            pos: [this.particleData[i].vertex_pos],
                            mom: this.particleData[i].mom
                        };
                    // console.log('Just added: ', event_data.Tracks.Particles[i-1]);
                }
            }
            var hitId = void 0;
            var particleId = void 0;
            // tslint:disable-next-line:radix
            var stepSize = parseInt(String(this.truthData.length / 10));
            for (var i = 1; i < this.truthData.length; i++) {
                // Now add the truth data - i.e. add the truth hits which match a particle to the particle (unsorted for the moment)
                hitId = i;
                // tslint:disable-next-line:radix
                particleId = parseInt(this.truthData[i][0]);
                for (var j = 0; j < eventData.Tracks.Particles.length; j++) {
                    // console.log(event_data.Tracks.Particles[j]);
                    if (eventData.Tracks.Particles[j].particle_id === particleId) {
                        // Found matching particle - add the truth hit position to the particles positions
                        eventData.Tracks.Particles[j].pos.push([parseFloat(this.truthData[i][1]), parseFloat(this.truthData[i][2]), parseFloat(this.truthData[i][3])]);
                    }
                }
                if (i % stepSize === 0) {
                    document.getElementById('info').innerHTML = 'Processed ' + 100 * i / this.truthData.length + '% of event data.';
                }
            }
        }
        var numParticleStubs = 0;
        for (var j = 0; j < eventData.Tracks.Particles.length; j++) {
            if (eventData.Tracks.Particles[j].pos.length < 3) {
                // console.log ('Track has less than 3 positions');
                // console.log(event_data.Tracks.Particles[j]);
                numParticleStubs++;
            }
        }
        var events = {};
        events[eventNum] = eventData;
        return eventData;
    };
    return TrackmlLoader;
}(PhoenixLoader));
export { TrackmlLoader };
//# sourceMappingURL=trackml-loader.js.map